<template>
    <div>
        <div v-if="!loading" class="login-page">

            <div class="login-form">
                <div class="logo">
                    <svg class="glow-svg" width="148" height="133" viewBox="-10 -10 168 153" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <filter id="glow" x="-20%" y="-20%" width="240%" height="240%">
            <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
            <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
    </defs>
    <g filter="url(#glow)" fill-rule="evenodd" clip-rule="evenodd">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8641 132.012H3.12476L0 129.184V111.352H3.62993V129.184H18.9319L15.8641 132.012ZM22.8592 132.012H19.2293V111.352H22.8592V132.012Z" fill="#E0C522"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M46.7124 114.18L30.6079 129.184H46.7124V132.012H26.0817V129.184L42.1862 114.18H26.0817V111.352H46.7124V114.18Z" fill="#E0C522"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M65.2329 123.289H53.8298V132.012H50.1998V111.352H53.8298V120.462H68.0602L65.2329 123.289ZM68.3576 111.352H71.9876V132.012H68.3576V111.352Z" fill="#E0C522"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M94.5573 131.983L78.8399 115.76V132.016H75.2099V111.352H78.8399L94.5573 127.636V111.352H98.1913V132.012H94.5573V131.983Z" fill="#E0C522"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M101.41 111.352H118.765L121.593 114.18H105.04V129.152L121.593 129.18L118.765 132.007H101.41V111.352ZM105.341 120.462L119.539 120.433V123.261H108.434L105.337 120.462H105.341Z" fill="#E0C522"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M147.996 114.18H137.575V132.012H133.945V114.18H123.466L126.534 111.352H144.932L148 114.18H147.996Z" fill="#E0C522"/>
    </g>
    <path filter="url(#glow)" d="M35.1159 79.3397H49.0067L60.1375 44.5236L60.3596 43.8445H87.684L87.906 44.5236L99.0369 79.3397H112.928L124.076 56.364L113.367 26.5888L91.8804 11.3355H56.2285L34.6719 26.641L23.9806 56.364L35.129 79.3397H35.1159ZM87.3314 90.9451L74.0414 84.0323L67.9557 87.1971L67.2505 87.5584L60.747 90.9451L63.5765 94.0532L73.1838 94.0314H74.0196H75.6085L84.5019 94.0532L87.3314 90.9451ZM59.3932 89.4563L66.3538 85.8389L72.3698 82.709L72.8878 82.4391V81.6338L72.3698 81.0461L61.709 69.0141L62.436 67.3991H85.638L86.365 69.0141L75.7043 81.0461L75.1862 81.6338V82.4391L75.7043 82.709L81.7202 85.8389L88.6809 89.4563L97.2217 80.0754L86.2605 45.7947H61.7613L50.8132 80.0362L59.3932 89.4607V89.4563ZM99.6289 45.7903H92.6291L94.1397 50.2479L99.6333 45.7903H99.6289ZM45.2717 43.8445H57.7912L57.3559 45.133L54.9486 52.2416L54.5003 53.565L53.412 52.6856L44.6535 45.5727L42.5292 43.8445H45.2673H45.2717ZM55.0792 45.7903H48.0098L53.5556 50.2958L55.0792 45.7903ZM91.2666 43.8445H105.105L102.981 45.5727L94.2746 52.6377L93.1907 53.5171L92.7423 52.1981L90.3438 45.133L89.9084 43.8445H91.2623H91.2666ZM64.5908 69.345L74.037 80.0057L83.4789 69.345H64.5908ZM49.3288 81.2899H40.8359L48.2057 83.6101L48.3406 83.6493L48.4669 83.7363L56.7944 89.4868L49.3288 81.2855V81.2899ZM107.186 81.2899H98.7452L91.3667 89.3954L99.5549 83.7363L99.6812 83.6493L99.8161 83.6101L107.186 81.2899ZM93.8306 10.356L114.273 24.8736L117.403 23.559L117.581 11.6184L104.787 2.39856L93.8262 10.3604L93.8306 10.356ZM70.3369 9.394H91.8499L104.213 0.413545L104.779 0L105.349 0.413545L119.122 10.3386L119.531 10.6346L119.523 11.1352L119.327 24.2163L119.318 24.8519L118.73 25.1L115.37 26.5148L126.013 56.1028L126.152 56.4902L125.974 56.8516L114.382 80.7414L114.199 81.1201L113.794 81.2464L100.521 85.4253L85.4683 95.8293L85.2201 95.999H84.9154L74.0065 95.9773L63.0846 95.999H62.7799L62.5318 95.8293L47.4787 85.4253L34.2017 81.2464L33.8013 81.1201L33.6141 80.7414L22.0261 56.8516L21.8476 56.4902L21.9869 56.1028L32.6303 26.5148L29.2697 25.1L28.682 24.8519L28.6733 24.2163L28.4774 11.1352L28.4687 10.6346L28.8779 10.3386L42.6511 0.413545L43.2257 0L43.7916 0.413545L56.1544 9.394H70.3282H70.3369ZM33.7708 24.8867L54.2086 10.3735L43.2257 2.39421L30.432 11.6141L30.6104 23.5547L33.7708 24.8867Z" fill="#E0C522"/>
</svg>
                </div>

                <div class="login-form__inputs">
                    <uzhnet-input-secondary v-model="login" :error="loginError" :placeholder="$t('loginPage.login')" :fontSize="'13px'" :alignText="'center'"/>
                    <uzhnet-input-secondary v-model="password" :error="loginError" :placeholder="$t('loginPage.password')" :fontSize="'13px'" :alignText="'center'" :contentType="'password'"/>
                </div>

                <uzhnet-button @click="processLogin" class="login-form__button" :label="'Log in'" />

                <div class="localization">
                    <div class="ukrainian-localization">
                        <img v-if="locale == 'ua'" src="@/assets/icons/localization/ukrainian-flag-active.svg">
                        <img @click="locale = 'ua'" v-if="locale != 'ua'" src="@/assets/icons/localization/ukrainian-flag.svg">
                    </div>
                    <div class="english-localization">
                        <img v-if="locale == 'en'" src="@/assets/icons/localization/usa-flag-active.svg">
                        <img @click="locale = 'en'" v-if="locale != 'en'" src="@/assets/icons/localization/usa-flag.svg">
                    </div>
                </div>
            </div>

            <div class="footer-block">
                <div class="social-icons">
                    <div class="social-icons__icon">
                        <img src="@/assets/icons/social-icons/site-icon.svg">
                    </div>
                    <div class="social-icons__icon">
                        <img src="@/assets/icons/social-icons/instagram-icon.svg">
                    </div>
                    <div class="social-icons__icon">
                        <img src="@/assets/icons/social-icons/facebook-icon.svg">
                    </div>
                    <div class="social-icons__icon">
                        <img src="@/assets/icons/social-icons/telegram-icon.svg">
                    </div>
                </div>

                <div class="all-rights-block">
                    <img src="@/assets/icons/specials/all-right-reserved.svg">
                </div>
            </div>
        </div>

        <LoadingView v-if="loading" />
    </div>
</template>

<script>
import '@/assets/scss/login-page.scss'

import { calculateFingerprint } from '@/services/fingerprint'
import { encryptMessage, decryptMessage } from '@/services/cryptoUtils'
import ApiManager from '@/services/ApiManager'
import { takePasswordLoginCredentials, rememberPasswordLoginAccount } from '@/services/passwordLogin'

import { getAccounts, addAccount, getAccountByLogin, updateAccount, dropAllAccounts } from '@/db/accountService';

import { useMainStore } from '@/store/mainStore'

import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'

import LoadingView from './LoadingView.vue';

import { useI18n } from 'vue-i18n';

function transformNotifications(data, t) {
    const months = [
        t('mounthes.january'),
        t('mounthes.february'),
        t('mounthes.march'),
        t('mounthes.april'),
        t('mounthes.may'),
        t('mounthes.june'),
        t('mounthes.july'),
        t('mounthes.august'),
        t('mounthes.september'),
        t('mounthes.october'),
        t('mounthes.november'),
        t('mounthes.december')
    ];

    const notificationsByMonth = {};
    if (!data?.notifications) {
        return notificationsByMonth;
    }
    data.notifications.forEach(notification => {
        const date = new Date(parseInt(notification.date) * 1000); // Перетворюємо дату
        const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`; // Формат: "місяць рік"

        if (!notificationsByMonth[monthYear]) {
            notificationsByMonth[monthYear] = []; // Створюємо масив для цього місяця
        }

        notificationsByMonth[monthYear].push(notification); // Додаємо сповіщення
    });

    // sort notifications by date
    for (const month in notificationsByMonth) {
        notificationsByMonth[month].sort((a, b) => {
            return b.date - a.date;
        });
    }

    return notificationsByMonth;
}

function transformNotificationsEng(data, t) {
    const months = [
        t('mounthes.january'),
        t('mounthes.february'),
        t('mounthes.march'),
        t('mounthes.april'),
        t('mounthes.may'),
        t('mounthes.june'),
        t('mounthes.july'),
        t('mounthes.august'),
        t('mounthes.september'),
        t('mounthes.october'),
        t('mounthes.november'),
        t('mounthes.december')
    ];

    const notificationsByMonth = {};

    if (!data?.notifications_eng) {
        return notificationsByMonth;
    }

    data.notifications_eng.forEach(notification => {
        const date = new Date(parseInt(notification.date) * 1000); // Перетворюємо дату
        const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`; // Формат: "місяць рік"

        if (!notificationsByMonth[monthYear]) {
            notificationsByMonth[monthYear] = []; // Створюємо масив для цього місяця
        }

        notificationsByMonth[monthYear].push(notification); // Додаємо сповіщення
    });

    // sort notifications by date
    for (const month in notificationsByMonth) {
        notificationsByMonth[month].sort((a, b) => {
            return b.date - a.date;
        });
    }

    return notificationsByMonth;
}

export default {
    name: 'LoginView',

    setup(props, { emit }) {
        const passwordLogin = takePasswordLoginCredentials()
        const fingerprint = ref('')

        const login = ref('')
        const password = ref('')

        const router = useRouter()
        const store = useMainStore()

        const loginError = ref(false)
        const loading = ref(false)

        const { t, locale } = useI18n()

        watch(locale, () => {
            localStorage.setItem('locale', locale);
        })

        onMounted(async () => {
            loading.value = true

            if (passwordLogin) {
                login.value = passwordLogin.login
                password.value = passwordLogin.password
                passwordLogin.password = ''
                try {
                    locale.value = localStorage.getItem('locale') || 'ua';
                    fingerprint.value = await calculateFingerprint()
                    if (login.value && password.value) {
                        await processLogin()
                    } else {
                        loginError.value = true
                    }
                } catch {
                    loginError.value = true
                } finally {
                    password.value = ''
                    loading.value = false
                }
                return
            }

            fingerprint.value = await calculateFingerprint()

            locale.value = localStorage.getItem('locale') || 'ua';

            const accounts = await getAccounts()
            if (accounts.length) {
                login.value = accounts[0]._data.login
                const maybeAccount = await getAccountByLogin(login.value)
                let auth_token = ''
                try {
                    auth_token = await decryptMessage(maybeAccount.token, fingerprint.value, maybeAccount.iv)
                } catch (error) {
                    console.error('Unable to decrypt saved account:', error.message);
                    await dropAllAccounts()
                    router.push('/')
                    loading.value = false
                    return
                }

                const response = await ApiManager.getUserInfo(auth_token)
                const responseData = response.data

                if (maybeAccount) {
                    const encryptedData = await encryptMessage(auth_token, fingerprint.value)
                    await updateAccount(login.value, {
                        login: login.value,
                        address: responseData.address_formatted,
                        token: encryptedData.encrypted,
                        iv: encryptedData.iv
                    })
                } else {
                    const encryptedData = await encryptMessage(auth_token, fingerprint.value)
                    await addAccount({
                        login: login.value,
                        address: responseData.address_formatted,
                        token: encryptedData.encrypted,
                        iv: encryptedData.iv
                    })
                }

                const clientInternetResponse = await ApiManager.getUserInternet(auth_token)
                const clientInternetData = clientInternetResponse.data

                const clientTvResponse = await ApiManager.getUserTv(auth_token)
                const clientTvData = clientTvResponse.data

                const allNotifications = await ApiManager.getAllNotifications(responseData.uid)

                const notificationsByMonth = transformNotifications(allNotifications.data, t)

                const notificationsByMonthEng = transformNotificationsEng(allNotifications.data, t)

                store.setCurrentNotificationsEng(notificationsByMonthEng)
                store.setCurrentNotifications(notificationsByMonth)

                store.setUserData(responseData)
                store.setUserInternetData(clientInternetData)
                store.setUserTvData(clientTvData)

                router.push('/main')
            }

            loading.value = false
        })

        const processLogin = async () => {
            loading.value = true
            loginError.value = false
            try {
                const response = await ApiManager.authorize({
                    'login': login.value,
                    'password': password.value
                })
                const responseData = response.data

                if (!responseData.auth_token || !responseData.user_data || responseData.user_data.status === false) {
                    loginError.value = true
                    login.value = ''
                    password.value = ''
                    return
                }

                const fullUserInfo = await ApiManager.getUserInfo(responseData.auth_token)
                const clientInternetResponse = await ApiManager.getUserInternet(responseData.auth_token)
                const clientTvResponse = await ApiManager.getUserTv(responseData.auth_token)
                const allNotifications = await ApiManager.getAllNotifications(responseData.user_data.uid)

                const maybeAccount = await getAccountByLogin(login.value)
                const encryptedData = await encryptMessage(responseData.auth_token, fingerprint.value)
                const account = {
                    login: login.value,
                    address: responseData.user_data.address_formatted,
                    token: encryptedData.encrypted,
                    iv: encryptedData.iv
                }

                if (maybeAccount) {
                    await updateAccount(login.value, account)
                } else {
                    await addAccount(account)
                }

                const notificationsByMonth = transformNotifications(allNotifications.data, t)
                const notificationsByMonthEng = transformNotificationsEng(allNotifications.data, t)

                store.setCurrentNotificationsEng(notificationsByMonthEng)
                store.setCurrentNotifications(notificationsByMonth)

                store.setUserData(fullUserInfo.data)
                store.setUserInternetData(clientInternetResponse.data)
                store.setUserTvData(clientTvResponse.data)

                if (passwordLogin) {
                    rememberPasswordLoginAccount(login.value)
                }

                emit('login-success')

                if (passwordLogin) {
                    await router.replace('/main')
                } else {
                    await router.push('/main')
                }
            } catch {
                loginError.value = true
                password.value = ''
            } finally {
                loading.value = false
            }
        }

        return {
            processLogin,
            login,
            password,
            loginError,
            loading,
            locale
        }
    },

    components: {
        LoadingView
    }
}
</script>

<style lang="css">

.footer-block {
    display: -webkit-inline-box;
    -webkit-box-pack: end;
    -webkit-box-orient: vertical;
}
</style>
